import styled, { css } from 'styled-components';
import { vars } from '../../theme';
import { Search16, Close16 } from '@honeybook/icons';
import HBInput from '../HBInput/HBInput';
import HBText from '../HBText/HBText';
import { mediumUp } from '../../styles/breakpoints';

const boxShadow = (level: '10' | '20') =>
    css`
        box-shadow: ${vars.shadow[level]};
    `;

export const Container = styled.div`
    ${boxShadow('10')}
    border-radius: ${vars.radius.full};
    transition: box-shadow 100ms ease;
    background-color: ${vars.colors.surface.item};
    display: flex;
    align-items: center;
    gap: 9px;
    flex: 1;
    padding: 8px 16px 8px 16px;
    ${mediumUp} {
        flex: initial;
        margin-right: auto;
        flex: 1;
        max-width: 320px;
        transform-origin: left;
    }
    &:hover,
    &:focus-within {
        ${boxShadow('20')}
    }
`;

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledSearch16 = styled(Search16)`
    padding-top: 3px;
`;

export const StyledCloseIcon = styled(Close16)`
    padding-top: 1.5px;
`;

export const Separator = styled.div`
    width: 1px;
    height: 22px;
    background-color: ${vars.colors.stroke.secondary};
`;

export const Search = styled(HBText)`
    &:hover {
        color: ${vars.colors.text.accentHover};
    }
`;

export const Input = styled(HBInput)`
    && {
        flex: 1;
        padding: 0 0 0 4px;
        height: 22px;
        &,
        &:hover,
        &:focus {
            background-color: inherit;
            border: none;
        }
        &::placeholder {
            color: ${vars.colors.text.secondary};
            opacity: 1;
        }
        + span {
            margin-top: unset;
        }
    }
`;
